import React, { useContext } from "react"

import Card from "./Card"
import ArticleSummary from "./ArticleSummary"
import PleaseWait from "components/PleaseWait"
import styles from "./ArticleListTags.css"
import { ReactFC } from "types"
import { PostsListHandlers, PostsListProps } from "pages/group/Posts"
import { PostsListItemAuthor } from "./AuthorAndMeta"
import { CircleContext } from "circle/CircleContext"
import { ListContainer } from "pages/group/ListContainer"

const ALWAYS_TRUE = () => true

export interface OverflowProps {
  overflowMenu
  hasOverflowMenu
}

type ArticleListItemProps = PostsListProps & PostsListHandlers & OverflowProps & {
  id: string
  selected?: boolean
}

export const ArticleListItem: ReactFC<ArticleListItemProps> = (props) => {
  const { postsFilter } = useContext(CircleContext)

  const {
    id,
    content,
    onPostClick,
    overflowMenu,
    hasOverflowMenu = ALWAYS_TRUE,
    selected
  } = props

  const post = content[id]

  if (!post) {
    return null
  }

  const type = post.type

  switch (postsFilter) {
    case "complete":
      if (!post.completed) {
        return null
      }
      break
    case "flag":
      if (!post.flagged) {
        return null
      }
      break      
    case "all":
      break
    default:
      if (postsFilter !== type) {
        return null
      }
  }

  if (type === "article" || type === "event" || type === "discussion" || type === "asset") {
    return (
      <ArticleSummary
        key={id}
        selected={selected}
        article={post}
        onClick={onPostClick}
        ArticleInfo={PostsListItemAuthor}
        overflowMenu={
          (hasOverflowMenu(post) && post.completed === false) || post.completed === undefined ? overflowMenu : null
        }
      />
    )
  }

  return (
    <Card key={id}>
      <div>UNKOWN_POST_TYPE: {type}</div>
    </Card>
  )

}

export const ArticleList: ReactFC<PostsListProps & PostsListHandlers & OverflowProps> = (props) => {
  const { order: ids, group } = props

  if (!ids.length) {
    return <PleaseWait i18nKey="posts.empty_list_placeholder" />
  }

  const sorted = group?.intro ? [group.intro, ...ids.filter(id => id !== group.intro)] : ids

  return (
    <ListContainer className={styles.post_list}>
      {
        sorted.map(id => <ArticleListItem id={id} key={id} selected={id === group?.intro} {...props} />)
      }
    </ListContainer>
  )
}

export default ArticleList
